<template>
  <div class="guarantor-published-list">
    <Header class="header" v-if="showHeader">
      <Menu mode="horizontal" theme="dark" active-name="1" class="top-bar">
        <div class="layout-logo">
          <img src="./../../assets/logo.png" height="42" style="margin-right:10px;">
          <div class="site-name-area">
            <h2 class="inline font-white">{{getConfig('TITLE')}}</h2>
            <div class="small font-grey">{{getConfig('SUBTITLE')}}</div>
          </div>
        </div>
        <div class="layout-nav">
        </div>
        <div class="pull-right" style="margin-right:20px">
          <Tooltip content="登录系统">
            <Button type="text" ghost @click="$router.push('/welcome')" icon="md-exit">登录系统</Button>
          </Tooltip>
        </div>
      </Menu>
    </Header>
    <div :style="showHeader?'padding:16px':''">
      <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
        <Panel name="filter" hide-arrow>
          <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
          <div class="pull-right">
            <Tooltip content="刷新结果">
              <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
            </Tooltip>
            <Divider type="vertical" />
            <Tooltip :content="(tableToolsPanel.indexOf('filter')>-1? '隐藏':'展开')+'筛选条件'">
              <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
            </Tooltip>
          </div>
          <div slot="content">
            <div class="padding-top-20"></div>
            <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
              <Row :gutter="8">
                <i-col span="8">
                  <FormItem label="名称" prop="name">
                    <Input v-model="filterModel.name" placeholder="输入名称" />
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="社会信用代码" prop="businessLicense">
                    <Input v-model="filterModel.businessLicense" placeholder="输入社会信用代码" />
                  </FormItem>
                </i-col>
              </Row>
              <Row :gutter="8">
                <i-col span="16">
                  <FormItem label="类别" prop="type" style="width: 100%">
                    <Select v-model="filterModel.type" filterable style="width:200px">
                      <Option v-for="(tp,idx) in $common.getEnumSelect($common.guarantorType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                    </Select>
                  </FormItem>
                </i-col>
              </Row>
              <Row :gutter="8">
                <i-col span="8">
                  <FormItem label="联系人" prop="contact">
                    <Input v-model="filterModel.contact" placeholder="输入联系人" />
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem label="联系电话" prop="contactTel">
                    <Input v-model="filterModel.contactTel" placeholder="输入联系电话" />
                  </FormItem>
                </i-col>
              </Row>
              <Row :gutter="8">
                <i-col span="16">
                  <FormItem style="width: 100%; text-align:right">
                    <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                    <Divider type="vertical" />
                    <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                  </FormItem>
                </i-col>
              </Row>
            </Form>
          </div>
        </Panel>
      </Collapse>
      <div class="padding-top-10"></div>
      <div class="text-right">
      </div>
      <div class="padding-top-10"></div>
      <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
      <Tabs type="card" class="tab-square" :animated="false" v-model="curTab">
        <TabPane label="合格名录" name="normal">
          <Table border ref="dataTable"
            size="small"
            stripe
            :columns="columns"
            @on-sort-change="tableSortChange"
            :data="data">
          </Table>
        </TabPane>
        <TabPane label="黑名单" name="blacklist">
          <Table border ref="dataTable"
            size="small"
            stripe
            :columns="columns"
            @on-sort-change="tableSortChange"
            :data="data">
          </Table>
        </TabPane>
      </Tabs>
    </div>
    <Footer v-if="showHeader" style="text-align:center" />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'
export default {
  name: 'guarantor-published-list',
  components: {
    Footer
  },
  props: {
  },
  data () {
    return {
      showHeader: false,
      tableToolsPanel: '',
      curTab: 'normal',
      columns: [
        {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '社会信用代码',
          key: 'businessLicense',
          resizable: true,
          width: 200,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '登记状态',
          key: 'status',
          width: 120,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: this.$common.guarantorStatusColor[params.row.status.toString()]
              }
            }, this.$common.guarantorStatus[params.row.status.toString()])
          }
        },
        {
          title: '类型',
          key: 'type',
          width: 120,
          resizable: true,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.$common.guarantorType[params.row.type.toString()])
          }
        },
        {
          title: '详情',
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '详情',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: this.showHeader?'GuarantorPublishedDetail':'guarantor-detail', params: {guarantorId: params.row.id}})
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        name: null,
        businessLicense: null,
        type: null,
        contact: null,
        status: 3,
        contactTel: null
      },
      departments: [],
      curDepartmentId: null
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    curTab: function (newVal) {
      if (newVal) {
        this.initData()
      }
    }
  },
  mounted () {
    let verifyObj = document.querySelector('#app > .guarantor-published-list')
    if (verifyObj) {
      this.showHeader = true
      document.body.style.overflow = 'visible'
      console.log(document.body.style.overflow)
    }
    this.initData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      if (this.curTab === 'blacklist') {
        this.filterModel.status = 40
      } else {
        this.filterModel.status = 3
      }
      let res = await this.$Api.Guarantor.listPublishedGuarantors(this.filterModel).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  background: linear-gradient(45deg, #3d3294, #3098ff);
  padding: 0;
}
.top-bar {
  background: transparent;
  padding: 0;
}
.top-bar-search {
  display: inline-block;
  width: 100px;
  margin-right: 20px;
  transition: all linear .3s;
  &.expand {
    width: 300px;
  }
}
.layout-logo {
  height: 50px;
  // background: #5b6270;
  color: #fefefe;
  text-align: center;
  border-radius: 3px;
  float: left;
  position: relative;
  top: 5px;
  margin-right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 10px;
  .site-name-area {
    line-height: initial;
    text-align: left;
  }
}
.layout-nav{
  margin: 0 auto;
  margin-right: 20px;
  display: inline-block;
}
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
